import React from 'react';
import { Group } from './CustomGroupFieldPlugin';

export const GroupDropdown = props => <Group {...props} asDropdown />;

export const GroupDropdownFieldPlugin = {
  name: 'group-dropdown',
  Component: GroupDropdown
}
